var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.796 8.26407L11.7355 7.20357L4.75 14.1891V15.2496H5.8105L12.796 8.26407ZM13.8565 7.20357L14.917 6.14307L13.8565 5.08257L12.796 6.14307L13.8565 7.20357ZM6.4315 16.7496H3.25V13.5673L13.3263 3.49107C13.4669 3.35047 13.6576 3.27148 13.8565 3.27148C14.0554 3.27148 14.2461 3.35047 14.3868 3.49107L16.5085 5.61282C16.6491 5.75347 16.7281 5.9442 16.7281 6.14307C16.7281 6.34195 16.6491 6.53268 16.5085 6.67332L6.43225 16.7496H6.4315Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.a5dd12931e497b81fc9716926c38df3b.svg";
export { ForwardRef as ReactComponent };